"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_footer.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Footer(_ref) {
  var children = _ref.children,
      buttonText = _ref.buttonText,
      onNext = _ref.onNext,
      nextDisabled = _ref.nextDisabled,
      onBackClick = _ref.onBackClick,
      showBriefInformation = _ref.showBriefInformation,
      showPendingApprovalInformation = _ref.showPendingApprovalInformation,
      showPendingApprovalButtons = _ref.showPendingApprovalButtons,
      returnFeedback = _ref.returnFeedback,
      openPaymentsInvoiceModal = _ref.openPaymentsInvoiceModal,
      saving = _ref.saving,
      nextBusy = _ref.nextBusy;
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "footer"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "footer__content"
    }, showBriefInformation ? /*#__PURE__*/_react.default.createElement("p", {
      className: "footer__content__info"
    }, "For more information about briefing your video, please refer to our", ' ', /*#__PURE__*/_react.default.createElement("a", {
      href: "https://help.shootsta.com",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Help Center")) : null, showPendingApprovalInformation ? /*#__PURE__*/_react.default.createElement("div", {
      className: "footer__content__info footer__content__info__approval-required"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      name: "alert",
      color: "goldenTainoi"
    }), "This video brief is Pending Review - Approval from your Organisation Admin") : null, children), /*#__PURE__*/_react.default.createElement("div", {
      className: "footer__actions"
    }, onBackClick && !showPendingApprovalButtons ? /*#__PURE__*/_react.default.createElement(_uiKit.LinkButton, {
      className: "footer__back-button",
      onClick: onBackClick
    }, "BACK") : null, onNext && !showPendingApprovalButtons && !showPendingApprovalInformation ? /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      className: "footer__next-button",
      disabled: nextDisabled,
      busy: nextBusy || saving,
      onClick: onNext,
      small: true
    }, buttonText) : null, showPendingApprovalButtons ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_uiKit.LinkButton, {
      className: "footer__back-button",
      onClick: returnFeedback
    }, "RETURN FEEDBACK"), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
      className: "footer__next-button footer__next-button__approve",
      onClick: openPaymentsInvoiceModal,
      small: true
    }, "APPROVE FOR EDITING")) : null))
  );
}

var _default = (0, _react.memo)(Footer);

exports.default = _default;